// src/data/articles/index.js
// Aggregates all article files and re-exports helpers.
// Add a new article: create src/data/articles/<slug>.js and import it here.

import benefitsOfLaughter from './benefits-of-laughter.js';
import howToWriteAFunnyJoke from './how-to-write-a-funny-joke.js';
import jokeStructures from './joke-structures.js';
import whatJokeWouldMakeAChildLaugh from './what-joke-would-make-a-child-laugh.js';
import typesOfHumor from './types-of-humor.js';
import historyOfHumor from './history-of-humor.js';
import howToBeNaturallyFunny from './how-to-be-naturally-funny.js';
import improveYourSenseOfHumor from './improve-your-sense-of-humor.js';
import qrCodeDigitalMenu from './qr-code-digital-menu.js';

export const articles = [
  ...benefitsOfLaughter,
  ...howToWriteAFunnyJoke,
  ...jokeStructures,
  ...whatJokeWouldMakeAChildLaugh,
  ...typesOfHumor,
  ...historyOfHumor,
  ...howToBeNaturallyFunny,
  ...improveYourSenseOfHumor,
  ...qrCodeDigitalMenu,
];

export const getArticleBySlug  = (slug) => articles.find((a) => a.slug === slug);
export const getAllArticleSlugs = ()     => articles.map((a) => a.slug);
export const getArticlesByLang = (lang) => articles.filter((a) => a.lang === lang);
